module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-2-e38aa895a9d83c515abb428082887105.svg";